import axios from 'axios'
import store from '@/store'
// const apiToken = 'keyZIIVNiQPvozEWb'
const apiToken = 'patH5bPxbXFwnCkaF.b7fba9bd7a192b540b473d22dc6a101222ace654ff0a11a2ce7b659e2713db50'
const client = async function (params) {
    const config = {
        method: params.method,
        url: params.url,
        headers: { Authorization: "Bearer " + apiToken },
        data: typeof params.data !== 'undefined' ? params.data : {},
        params: typeof params.params !== 'undefined' ? params.params : {},
        responseType: typeof params.responseType !== 'undefined' ? params.responseType : null
    }

    try {
        return await axios(config)
    }
    catch(e) {
        console.log('http client error:', e)
        setTimeout(()=>{
            store.commit('SET_ERROR', 'HTTP server error. Are you offline?')
        }, 700)
    }
}

export default client